// extracted by mini-css-extract-plugin
module.exports = {"set":"accordion-set_set__kaTgc","hidden":"accordion-set_hidden__l_mTS"};